import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import { storage } from "../libs";
import { EncryptStorage } from "encrypt-storage";

import Home from "./Homepage/Home";
import Login from "./Account/Login";
import Register from "./Account/Register";
import Verify from "./Account/Verification";
import Forgot from "./Account/Forgot";
// import Reset from "./Account/Reset";
import Navbar from "../components/Main/Navbar";
import ScrollTop from "../components/Main/ScrollTop";
import Footer from "../components/Main/Footer";
import Product from "./Product/Product";
// import Media from "./Product/Media";
import Profile from "./Profile/Profile";
import PasswordNotif from "./Profile/PasswordNotif";
import HistoryDetail from "./History/Detail";
import Confirmation from "./History/Confirmation";
import Cart from "./Cart/Cart";
import Track from "./Track/Track";
import Result from "./Track/Result";
import Empty from "./Homepage/404";
import Faq from "./Homepage/Faq";
import Notification from "./Notification/Notification";

export const RouterControl = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loc, setLoc] = useState("");

  // Digunakan ketika akses account
  const AccountRoute = ({ component: Component, authenticated, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          return authenticated ? <Redirect to="/" /> : <Component {...props} />;
        }}
      />
    );
  };

  // Digunakan ketika akses profile
  const PrivateRoute = ({ component: Component, authenticated, ...rest }) => {
    const encryptStorage = EncryptStorage(process.env.REACT_APP_SECRET);
    const xtoken = encryptStorage.getItem("x-token");
    const token = localStorage.getItem("token");

    return (
      <Route
        {...rest}
        render={(props) => {
          return !xtoken && !token ? (
            <Redirect to="/" />
          ) : (
            <Component {...props} />
          );
        }}
      />
    );
  };

  const onLocation = (value) => {
    setLoc(value);
  };

  useEffect(() => {
    const fetchAuth = async () => {
      const data = await storage();

      if (data.token && data.xtoken) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    };
    fetchAuth();
    setLoading(false);
  }, [loc]);

  return (
    !loading && (
      <Router>
        <Navbar props={{ onLocation }} />

        <ScrollTop>
          <Switch>
            <Route path="/" component={Home} exact />
            <Route path="/frequently-ask-question" component={Faq} />
            <AccountRoute
              authenticated={isAuthenticated}
              path="/account/login"
              component={Login}
            />
            <AccountRoute
              authenticated={isAuthenticated}
              path="/account/register"
              component={Register}
            />
            <Route path="/account/verification" component={Verify} />
            <AccountRoute
              authenticated={isAuthenticated}
              path="/account/forgot"
              component={Forgot}
            />
            {/* <AccountRoute
              authenticated={isAuthenticated}
              path="/account/reset"
              component={Reset}
            /> */}
            <Route exact path="/product/paket/:id" component={Product} />
            <Route exact path="/product/satuan/:id" component={Product} />
            <Route exact path="/media/:id" component={Product} />
            <Route path="/lacak" component={Track} exact />
            <Route path="/result/:id" component={Result} exact />

            <PrivateRoute
              authenticated={isAuthenticated}
              path="/profile"
              exact
              component={Profile}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/profile/setting"
              component={Profile}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/profile/history"
              component={Profile}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/profile/notification"
              component={Notification}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/history/detail/pemeriksaan/:id"
              component={HistoryDetail}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/history/detail/pembelian/:id"
              component={HistoryDetail}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/history/confirmation/pemeriksaan/:id"
              component={Confirmation}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/history/confirmation/pembelian/:id"
              component={Confirmation}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/profile/n/password"
              component={PasswordNotif}
            />
            <PrivateRoute
              authenticated={isAuthenticated}
              path="/cart"
              component={Cart}
            />
            <Route path="*" exact={true} component={Empty} />
          </Switch>
        </ScrollTop>
        <Footer />
      </Router>
    )
  );
};
